import {
  SubscriptionTier,
  TierCapability,
} from "src/data/landing/queries/subscriptionTiers";

/**
 * The capability names a tier grants, deduplicated. The catalog lists a
 * capability once per marketing angle — `booking_management` appears twice on
 * the reservation tier, once for the booking system and once for the no-show
 * blacklist — so a raw map over `capabilities` would count it twice.
 */
export const tierCapabilityNames = (tier: SubscriptionTier): string[] =>
  Array.from(new Set((tier.capabilities ?? []).map((entry) => entry.name)));

export const tierGrantsCapability = (
  tier: SubscriptionTier,
  capability: string,
): boolean =>
  (tier.capabilities ?? []).some((entry) => entry.name === capability);

/**
 * Everything the tier promises, as translation keys in the order the backend
 * sells them: the capabilities that carry a sentence first, then the perks no
 * capability backs. A capability with no `perkDescriptionKey` is granted but
 * not advertised, and drops out here.
 */
export const tierPerkKeys = (tier: SubscriptionTier): string[] => [
  ...(tier.capabilities ?? [])
    .map((entry: TierCapability) => entry.perkDescriptionKey)
    .filter((key): key is string => !!key),
  ...(tier.additionalPerks ?? []),
];
